const klipyTagRegex = /<klipy-tag\s+id="([^"]+)"\s+searchterm="([^"]*)"\s*><\/klipy-tag>/g;

export { klipyTagRegex };
